// Theme: ascension
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'ascension',
  name: 'ASCENSION',
  tagline: 'ASCENSION',
  description: 'Dourado transcendente de elevacao celestial.',
  category: 'premium-status',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0A0804', '#1A1608', '#FDE68A', '#FEFCE8'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-ascension'
  },
  colorVars: {
    '--accent': '#FDE68A',
    '--accent-foreground': '#0A0804',
    '--background': '#0A0804',
    '--border': '#8A7820',
    '--card': '#1A1608',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEFCE8',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0804',
    '--foreground': '#FEFCE8',
    '--hold-fill': '#FDE68A',
    '--input': '#8A7820',
    '--modal-bg': '#0A0804',
    '--modal-border': '#8A7820',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#8A7820',
    '--muted-foreground': '#FEFCE8',
    '--nav-active': '#FDE68A',
    '--nav-bg': '#1A1608',
    '--popover': '#1A1608',
    '--popover-foreground': '#FEFCE8',
    '--primary': '#FDE68A',
    '--primary-foreground': '#0A0804',
    '--ring': '#FDE68A',
    '--secondary': '#8A7820',
    '--secondary-foreground': '#FEFCE8',
    '--streak': '#FDE68A',
    '--success': '#22c55e',
    '--success-foreground': '#0A0804',
    '--xp': '#FDE68A',
    '--xp-bg': '#1A1608'
  },
  resolvedVars: {
    '--accent': '#FDE68A',
    '--accent-foreground': '#0A0804',
    '--accent-foreground-hsl': '40 43% 3%',
    '--accent-foreground-oklch': 'from #0A0804 l c h',
    '--accent-hsl': '48 97% 77%',
    '--accent-oklch': 'from #FDE68A l c h',
    '--background': '#0A0804',
    '--background-hsl': '40 43% 3%',
    '--background-oklch': 'from #0A0804 l c h',
    '--border': '#8A7820',
    '--border-hsl': '50 62% 33%',
    '--border-oklch': 'from #8A7820 l c h',
    '--border-w': '1px',
    '--card': '#1A1608',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FEFCE8',
    '--card-foreground-hsl': '55 92% 95%',
    '--card-foreground-oklch': 'from #FEFCE8 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '47 53% 7%',
    '--card-oklch': 'from #1A1608 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0804',
    '--destructive-foreground-hsl': '40 43% 3%',
    '--destructive-foreground-oklch': 'from #0A0804 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FEFCE8',
    '--foreground-hsl': '55 92% 95%',
    '--foreground-oklch': 'from #FEFCE8 l c h',
    '--hold-fill': '#FDE68A',
    '--hold-fill-hsl': '48 97% 77%',
    '--hold-fill-oklch': 'from #FDE68A l c h',
    '--input': '#8A7820',
    '--input-hsl': '50 62% 33%',
    '--input-oklch': 'from #8A7820 l c h',
    '--modal-bg': '#0A0804',
    '--modal-bg-hsl': '40 43% 3%',
    '--modal-bg-oklch': 'from #0A0804 l c h',
    '--modal-border': '#8A7820',
    '--modal-border-hsl': '50 62% 33%',
    '--modal-border-oklch': 'from #8A7820 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#8A7820',
    '--muted-foreground': '#FEFCE8',
    '--muted-foreground-hsl': '55 92% 95%',
    '--muted-foreground-oklch': 'from #FEFCE8 l c h',
    '--muted-hsl': '50 62% 33%',
    '--muted-oklch': 'from #8A7820 l c h',
    '--nav-active': '#FDE68A',
    '--nav-active-hsl': '48 97% 77%',
    '--nav-active-oklch': 'from #FDE68A l c h',
    '--nav-bg': '#1A1608',
    '--nav-bg-hsl': '47 53% 7%',
    '--nav-bg-oklch': 'from #1A1608 l c h',
    '--popover': '#1A1608',
    '--popover-foreground': '#FEFCE8',
    '--popover-foreground-hsl': '55 92% 95%',
    '--popover-foreground-oklch': 'from #FEFCE8 l c h',
    '--popover-hsl': '47 53% 7%',
    '--popover-oklch': 'from #1A1608 l c h',
    '--primary': '#FDE68A',
    '--primary-foreground': '#0A0804',
    '--primary-foreground-hsl': '40 43% 3%',
    '--primary-foreground-oklch': 'from #0A0804 l c h',
    '--primary-hsl': '48 97% 77%',
    '--primary-oklch': 'from #FDE68A l c h',
    '--radius': '12px',
    '--ring': '#FDE68A',
    '--ring-hsl': '48 97% 77%',
    '--ring-oklch': 'from #FDE68A l c h',
    '--secondary': '#8A7820',
    '--secondary-foreground': '#FEFCE8',
    '--secondary-foreground-hsl': '55 92% 95%',
    '--secondary-foreground-oklch': 'from #FEFCE8 l c h',
    '--secondary-hsl': '50 62% 33%',
    '--secondary-oklch': 'from #8A7820 l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#FDE68A',
    '--streak-hsl': '48 97% 77%',
    '--streak-oklch': 'from #FDE68A l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0A0804',
    '--success-foreground-hsl': '40 43% 3%',
    '--success-foreground-oklch': 'from #0A0804 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(48 97% 77% / 0.15)',
    '--xp': '#FDE68A',
    '--xp-bg': '#1A1608',
    '--xp-bg-hsl': '47 53% 7%',
    '--xp-bg-oklch': 'from #1A1608 l c h',
    '--xp-hsl': '48 97% 77%',
    '--xp-oklch': 'from #FDE68A l c h'
  }
}
